import React, { useEffect, useState, forwardRef } from "react";
import axios from 'axios';
import '../css/contentSection.css';
import { Link, useNavigate } from "react-router-dom";
import AOS from 'aos';
import 'aos/dist/aos.css';
import Navbar from "../landingComponents/Navbar";
import Footer from "../landingComponents/Footer";
// import Course from '../images/webpage 1-01-01 (1).png';
import TitleBar from "../landingComponents/TitleBar";
import { BaseImgUrl, getEnrolledCourse } from "../Services/Api";






const MyCourses = forwardRef((props, ref) => {
  const navigate=useNavigate();
  const { data, image } = props;
  const [hoveredCard, setHoveredCard] = useState(null);
  const [courses, setCourses] = useState([]);
  // console.log(courses);





  const relatedCourses = [
    {
      id: 7,
      title: "Advanced JavaScript",
      description: "Deep dive into modern JavaScript concepts",
      image: "https://images.unsplash.com/photo-1579468118864-1b9ea3c0db4a?ixlib=rb-1.2.1&auto=format&fit=crop&w=500&q=60"
    },
    {
      id: 8,
      title: "Backend Development",
      description: "Build scalable APIs with Node.js and Express",
      image: "https://images.unsplash.com/photo-1555066931-4365d14bab8c?ixlib=rb-1.2.1&auto=format&fit=crop&w=500&q=60"
    },
    {
      id: 9,
      title: "Database Design",
      description: "SQL and NoSQL database architecture",
      image: "https://images.unsplash.com/photo-1486312338219-ce68d2c6f44d?ixlib=rb-1.2.1&auto=format&fit=crop&w=500&q=60"
    }
  ];

  const getLevelColor = (level) => {
    switch (level) {
      case 'Beginner': return '#4CAF50';
      case 'Intermediate': return '#2196F3';
      case 'Advanced': return '#9C27B0';
      default: return '#607D8B';
    }
  };




  useEffect(() => {
     document.title = 'Course';
    try {
      const courseFetch = async () => {
        const data = await getEnrolledCourse();
        setCourses(data.data);
        // console.log(data);

      }
      courseFetch();
    } catch (err) {
      console.log(err);

    }

    // axios.get('http://127.0.0.1:8000/api/category')
    //   .then(response => {
    //     const data = Object.values(response.data); // 🔁 Convert object to array
    //     console.log('Converted:', data);
    //     setCourses(data);
    //   })
    //   .catch(err => console.error(err));
  }, []);



  return (
    <>
      <Navbar />
      <TitleBar title={data} image={image} />
      <div className="content-section" >


        <div className="courses-container" >
          {Array.isArray(courses) ? courses.map(category => (
            <div key={category.id} className="course-card" data-aos="fade-up" onClick={()=>navigate(`/category/${category.hashed_id}`)}>
              <div className="card-image">
                <img
                  src={`${BaseImgUrl}/${category.new_category_img_url}`}
                  alt={category.category_name}
                />

                <div className="card-category">{category.short_name}</div>
              </div>

              <div className="card-content" >
                <div className="card-header" >
                   <h3>  {category.category_full_name
                    .toLowerCase()
                    .replace(/\b\w/g, (char) => char.toUpperCase())}</h3>
                  {/* <h3>{category.category_name}</h3> */}
                  <div className="card-duration">
                    {/* <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                    <circle cx="12" cy="12" r="10"></circle>
                    <polyline points="12 6 12 12 16 14"></polyline>
                  </svg>
                  {category.duration} */}
                  </div>

                </div>

                <p className="card-description">{category.category_desc}</p>

                <div className="card-footer" data-aos="fade-right">
                  <Link className="enroll-btn" to={`/category/${category.hashed_id}`}>
                    Explore
                    <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                      <path d="M5 12h14"></path>
                      <path d="M12 5l7 7-7 7"></path>
                    </svg>
                  </Link>
                </div>
              </div>
            </div>
          )) : (
            <div className="eCourse-card1 improved-card">
              <div className="eCourse-card-info1">
                <h4 className="no-course-title">No Course Enrolled</h4>
                <p className="no-course-desc">You haven't enrolled in any courses yet. Discover and start learning today!</p>
                <div className="explore-btn-container">
                  <Link to="/" className="eCourse-btn1 eCourse-btn-outline1">Explore Courses</Link>
                </div>
              </div>
            </div>

          )}
        </div>

      </div>
      <Footer />
    </>
  );
})

export default MyCourses;